export default __webpack_public_path__ + "static/media/team-lg.4166ebff.png";